import { render } from "./contentsMainView.vue?vue&type=template&id=cd82f7ee"
import script from "./contentsMainView.vue?vue&type=script&lang=js"
export * from "./contentsMainView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__